__turbopack_context__.v({
  "carousel": "E6DTgW_carousel",
  "dot": "E6DTgW_dot",
  "dotActive": "E6DTgW_dotActive",
  "dots": "E6DTgW_dots",
  "plaaBannerFade": "E6DTgW_plaaBannerFade",
  "slide": "E6DTgW_slide",
});
